import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home/Home'
import Heartbeat from '@/components/views/raw-data/RawData'
import HealthReport from '@/components/views/health-report/HealthReport'

Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/raw-data',
      name: 'rawData',
      component: Heartbeat
    },
    {
      path: '/health-report',
      name: 'healthReport',
      component: HealthReport
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js